import { RefObject, SyntheticEvent, useMemo, useState } from "react"
import { Box, Tab, Tabs, useTheme } from "@mui/material"
import ComplianceWrapper from "./ComplianceWrapper"
import TabContent from "./TabContent"
import { Compliance } from "../../../../types"
import { Medication } from "../../../corp/medications/types"
import { Device } from "../../../corp/devices/types"
import { getKitsById, getKitsByStatus } from "./utils/helpers"
import { KitType } from "./enums"

type MedsDevicesContainer = {
  type: KitType,
  items: (Medication | Device)[],
  label: string,
  header: string,
  image: string,
  compliance: Partial<Compliance> | null,
  contentRef: RefObject<HTMLDivElement>,
  fetchItems: (customerNumber: string) => Promise<void>,
}

const MedsDevicesContainer = (props: MedsDevicesContainer) => {
  const {
    type,
    items,
    label,
    header,
    image,
    compliance,
    contentRef,
    fetchItems,
  } = props

  const theme = useTheme()

  const [tabIndex, setTabIndex] = useState(0)

  const kitsById = useMemo(() => {
    return getKitsById(items)
  }, [items])

  const kitsByStatus = useMemo(() => {
    return getKitsByStatus(kitsById)
  }, [kitsById])

  const tabs = [
    `Active (${kitsByStatus.active.length})`,
    `Inactive (${kitsByStatus.inactive.length})`
  ]

  const handleTab = (e: SyntheticEvent, nextTabIndex: number) => setTabIndex(nextTabIndex)

  return (
    <>
      <Box sx={{ color: theme.palette.color50555b.main }}>
        <ComplianceWrapper
          label={label}
          image={image}
          items={items}
          compliance={compliance}
        />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="flex flex-end m-b-16">
          <Tabs value={tabIndex} onChange={handleTab}>
            { tabs.map((tab, index) => <Tab key={index} label={tab} />) }
          </Tabs>
        </Box>
        <TabContent
          type={type}
          items={items}
          header={header}
          kitsByStatus={kitsByStatus}
          tabIndex={tabIndex}
          contentRef={contentRef}
          fetchItems={fetchItems}
        />
      </Box>
    </>
  )
}

export default MedsDevicesContainer
